import { render } from "./AddToReturnBoxCompleteModal.vue?vue&type=template&id=023c4b22"
import script from "./AddToReturnBoxCompleteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToReturnBoxCompleteModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/AddToReturnBoxCompleteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "023c4b22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('023c4b22', __exports__)) {
    console.log('reload')
    api.reload('023c4b22', __exports__)
  }
  
  module.hot.accept("./AddToReturnBoxCompleteModal.vue?vue&type=template&id=023c4b22", () => {
    console.log('re-render')
    api.rerender('023c4b22', render)
  })

}


export default __exports__